import { render, staticRenderFns } from "./adminList.vue?vue&type=template&id=15bd9a49&scoped=true&"
import script from "./adminList.vue?vue&type=script&lang=js&"
export * from "./adminList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bd9a49",
  null
  
)

export default component.exports